<ng-container *ngIf="!cached">
    <img class="w-full transition-opacity duration-300 {{imgClass}}" [alt]="alt" [ngClass]="{'!hidden': !loaded && !placeholder}" [hidden]="!loaded && !placeholder" [defaultImage]="placeholder" [errorImage]="placeholder" [lazyLoad]="image | SafeImageLoader | async" (onStateChange)="onLazyLoadStateChange($event)">
    <skeleton *ngIf="!loaded && skeleton && !placeholder" type="image" [ngClass]="imgClass"></skeleton>
</ng-container>

<img *ngIf="cached" class="w-full" [alt]="alt" [ngClass]="imgClass" [src]="image">